import { OnInit, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { PermissionsService } from '../services/permissions.service';
var AccountHasPermissionDirective = /** @class */ (function () {
    function AccountHasPermissionDirective(el, templateRef, viewRef, authService, permissionService) {
        this.el = el;
        this.templateRef = templateRef;
        this.viewRef = viewRef;
        this.authService = authService;
        this.permissionService = permissionService;
        this.accountPermissions = [];
        this.currentUser = {};
        this.subscriptions = {};
        this.hidden = true;
    }
    Object.defineProperty(AccountHasPermissionDirective.prototype, "accountHasPermission", {
        set: function (value) {
            this._accountAllowed(value);
        },
        enumerable: true,
        configurable: true
    });
    AccountHasPermissionDirective.prototype.ngOnInit = function () { };
    AccountHasPermissionDirective.prototype.ngOnDestroy = function () {
        var _this = this;
        Object.keys(this.subscriptions).forEach(function (key) {
            _this.subscriptions[key].unsubscribe();
        });
    };
    /**
     * Get value from directive to check if user have permission for that section
     * @param val array of permissions
     */
    AccountHasPermissionDirective.prototype._accountAllowed = function (val) {
        var _this = this;
        this.accountPermissions = val || [];
        this.subscriptions.currentContract = this.authService.currentUser.subscribe(function (data) {
            _this.currentUser = data || {};
            if (!_this.currentUser.accounts)
                return _this.updateView(_this.accountPermissions, _this.currentUser.permissions);
            var account = _this.currentUser.accounts
                .find(function (x) { return _this.authService.accountId.toString() === x.accountId.toString(); });
            _this.currentUser.permissions = account ? account.accountPermissions : [];
            _this.updateView(_this.accountPermissions, _this.currentUser.permissions);
        });
    };
    /**
     * Display or hide an element depending of user permissions
     * @param sectionPermissions section to check if have permissions
     * @param userPemissions user list of permissions
     */
    AccountHasPermissionDirective.prototype.updateView = function (sectionPermissions, userPemissions) {
        if (this.permissionService.checkPermissions(sectionPermissions, userPemissions)) {
            if (this.hidden) {
                this.viewRef.createEmbeddedView(this.templateRef);
                this.hidden = false;
            }
        }
        else {
            this.hidden = true;
            this.viewRef.clear();
        }
    };
    return AccountHasPermissionDirective;
}());
export { AccountHasPermissionDirective };
